import utils from './utils';
import store from '../store/index';
let service = {};

// 列表新增按钮
service.listAddFun = function (vm, editConfig) {
  vm.$store.commit('setEditId', '');
  // vm.$router.push({
  //     name: editConfig['editRouter']
  // });
  window.open(vm.$router.resolve({name: editConfig['editRouter'],query: {editId: ''}}).href,'_blank')
};

// 列表编辑按钮
service.listEditFun = function (vm, selections, editConfig) {
    if (selections.length <= 0) {
        utils.error('请选择需要操作的记录');
        return;
    } else if (selections.length > 1) {
        utils.error('请选择一条记录进行操作');
        return;
    } else {
        const editId = selections[0][editConfig['editKey']];
        let routeName = editConfig['editRouter'];
        vm.$store.commit('setEditId', editId);
        if(selections[0].stepMatrix){
            switch (selections[0].stepMatrix) {
                case "0,1,0,0,0,0,0,0,0,0,0":
                  routeName = "surveyDetail1";
                  break;
                case "0,0,1,0,0,0,0,0,0,0,0":
                  routeName = "surveyDetail2";
                  break;
                case "0,0,0,1,0,0,0,0,0,0,0":
                  routeName = "surveyDetail3";
                  break;
                case "0,0,0,0,1,0,0,0,0,0,0":
                  routeName = "surveyDetail4";
                  break;
                case "0,0,0,0,0,1,0,0,0,0,0":
                  routeName = "surveyDetail5";
                  break;
                case "0,0,0,0,0,0,1,0,0,0,0":
                  routeName = "surveyDetail6";
                  break;
                case "1,1,0,0,0,0,0,0,0,0,0":
                  routeName = "installDetail2";
                  break;
                case "1,0,1,0,0,0,0,0,0,0,0":
                  routeName = "installDetail3";
                  break;
                case "1,0,0,1,0,0,0,0,0,0,0":
                  routeName = "installDetail4";
                  break;
                case "1,0,0,0,1,0,0,0,0,0,0":
                  routeName = "installDetail5";
                  break;
                case "1,0,0,0,0,1,0,0,0,0,0":
                  routeName = "installDetail6";
                  break;
                case "1,0,0,0,0,0,1,0,0,0,0":
                  routeName = "review";
                  break;
                case "2,0,0,0,0,0,0,1,0,0,0":
                  routeName = "orderAudit";
                  break;
                case "2,1,0,0,0,0,0,0,0,0,0":
                  routeName = "orderAudit";
                  break;
                case "2,0,1,0,0,0,0,0,0,0,0":
                  routeName = "orderFinish";
                  break;
                case "3,0,1,0,0,0,0,0,0,0,0":
                  routeName = "uInstall";
                  break;
                case "3,1,0,0,0,0,0,0,0,0,0":
                  routeName = "uInspect";
                  break;
                case "4,0,1,0,0,0,0,0,0,0,0":
                  routeName = "cInstall";
                  break;
                case "4,1,0,0,0,0,0,0,0,0,0":
                  routeName = "cInspect";
                  break;
                case "5,1,0,0,0,0,0,0,0,0,0":
                  routeName = "orderStop";
                  break;
                case "5,0,0,0,1,0,0,0,0,0,0":
                  routeName = "orderEnd";
                  break;
                case "5,0,1,0,0,0,0,0,0,0,0":
                  if(editConfig.editType== '01'){
                    routeName = "stopAudit1";
                  }else{
                      return utils.error('请点击一审按钮进行操作');
                  }
                  break;
                case "5,0,0,1,0,0,0,0,0,0,0":
                  if(editConfig.editType== '02'){
                    routeName = "stopAudit2";
                  }else{
                      return utils.error('请点击二审按钮进行操作');
                  }
                  break;
                case "2,0,0,1,0,0,0,0,0,0,0":
                    if(editConfig.editType== '01'){
                       routeName = editConfig['editRouter']; 
                    }else{
                        return utils.error('请点击一审按钮进行操作');
                    }
                  break;
                case "2,0,0,0,1,0,0,0,0,0,0":
                    if(editConfig.editType== '02'){
                       routeName = editConfig['editRouter']; 
                    }else{
                        return utils.error('请点击二审按钮进行操作');
                    }
                  break;
                case "2,0,0,0,0,1,0,0,0,0,0":
                    if(editConfig.editType== '03'){
                       routeName = editConfig['editRouter']; 
                    }else{
                        return utils.error('请点击质量审核按钮进行操作');
                    }
                  break;
              }
        }
        vm.$router.push({
            name: routeName
        });
    }
};

// 列表总编辑按钮
service.tableEditFun = function (vm, selections, editConfig) {
  if (selections.length <= 0) {
      utils.error('请选择需要操作的记录');
      return;
  } else if (selections.length > 1) {
      utils.error('请选择一条记录进行操作');
      return;
  } else {
      const editId = selections[0][editConfig['editKey']];
      let routeName = editConfig['editRouter'];
      vm.$store.commit('setEditId', editId);
      // vm.$router.push({
      //     name: routeName
      // });
      window.open(vm.$router.resolve({name: routeName,query: {editId: editId}}).href,'_blank')
  }
};

// 核销、结算展示订单详情 WK
service.verifyShowOrderDetail = function (vm, selections) {
    if (selections.length <= 0) {
        utils.error('请选择需要操作的记录');
        return;
    } else if (selections.length > 1) {
        utils.error('请选择一条记录进行操作');
        return;
    } else {
        let routeData = vm.$router.resolve({name: 'allOrderDetail'});
        window.open(routeData.href, '_blank');
    }
};



/**
 * 表单提交
 * @param vm         vue实例
 * @param url        请求地址
 * @param editFlag   是否为编辑
 * @param formInfo   表单信息
 * @param listRouter 跳转的List路由名称
 * @Auth wk 2019-03-13
 *  */
service.submitForm = function (vm, url, editFlag, formInfo, listRouter, msg = '保存成功', callback) {
    // formInfo.corpNo = vm.$store.state.corpNo;
    vm.$U.showLoading(vm);
    if (editFlag) {
        vm.$H.put(vm, url, formInfo).then(res => {
            vm.$U.hideLoading(vm);
            if (listRouter) {
                vm.$U.success(msg);
                vm.$router.push({
                    name: listRouter
                });
            } else {
                callback && callback();
            }
        });
    } else {
        vm.$H.post(vm, url, formInfo).then(res => {
            vm.$U.hideLoading(vm);
            if (listRouter) {
                vm.$U.success(msg);
                vm.$router.push({
                    name: listRouter
                });
            } else {
                callback && callback(res);
            }
        });
    }
};



/**
 * 带文件的表单提交
 * @param vm         vue实例
 * @param url        请求地址
 * @param editFlag   是否为编辑
 * @param formInfo   表单信息
 * @param listRouter 跳转的List路由名称
 * @Auth wk 2019-03-13
 *  */
service.submitFormWithFile = function (vm, editFlag, editApi, addApi, formInfo, listRouter, msg = '保存成功', callback) {
    // formInfo.corpNo = vm.$store.state.corpNo;
    vm.$U.showLoading(vm);
    if (editFlag) {
        vm.$H.postFormData(vm, editApi, formInfo).then(res => {
            vm.$U.hideLoading(vm);
            if (listRouter) {
                vm.$U.success(msg);
                vm.$router.push({
                    name: listRouter
                });
            } else {
                callback && callback();
            }
        });
    } else {
        vm.$H.postFormData(vm, addApi, formInfo).then(res => {
            vm.$U.hideLoading(vm);
            if (listRouter) {
                vm.$U.success(msg);
                vm.$router.push({
                    name: listRouter
                });
            } else {
                callback && callback();
            }
        });
    }
};

// 获取表单的基本信息
service.getFormInfo = function (vm, url, callback) {
    vm.$U.showLoading(vm);
    vm.$H.get(vm, url, {}).then(res => {
        vm.$U.hideLoading(vm);
        callback(res)
    });
};

// 列表的文件导出
service.listExportFun = function (vm, url, queryInfo) {
    vm.$U.showLoading(vm);
    vm.$H.get(vm, url, queryInfo).then(res => {
        vm.$U.hideLoading(vm);
        vm.$U.saveExcelFile(res.data.data);
    });
}

// 判断是否是用户权限的按钮
service.checkUserAuth = function (auth) {
    const userAuths = store.state.curUserAuthList;
    var index = $.inArray(auth, userAuths);
    if (index >= 0) {
        return true;
    }
    return false;
}

// 判断是否是用户菜单权限
service.checkUserMenu = function (menu) {
    const userMenus = store.state.curUserMenuList;
    // console.log(userMenus)
    var index = $.inArray(menu, userMenus);
    if (index >= 0) {
        return true;
    }
    return false;
}

// 判断列表按钮列表
service.checkListAuthBtn = function (operatesList) {
  // 按钮权限处理
  let filterAuth = [];
  operatesList.forEach(a=>{
      if(a.auth){
          if(service.checkUserMenu(a.authName)){
              filterAuth.push(a)
          }
      }else{
          filterAuth.push(a)
      }
  })
  return filterAuth
}


export default service;